import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("foreignObject", {
      width: "16.877",
      height: "11.955",
      x: ".806",
      y: "3.36"
    }, [
      _createElementVNode("div", {
        xmlns: "http://www.w3.org/1999/xhtml",
        style: {"backdrop-filter":"blur(.88px)","clip-path":"url(#a)","height":"100%","width":"100%"}
      })
    ], -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      d: "m3.764 13.052.013-.048.05-.17c.139-.454.221-.727.507-1.658.476-1.555 1.08-3.544 1.452-4.77.136-.45.172-.537.218-.594a.5.5 0 0 1 .203-.15c.068-.028.162-.037.632-.037h8.01c.22 0 .35 0 .446.009.048.004.071.01.08.012a.1.1 0 0 1 .043.052q.002.013-.006.08c-.012.096-.04.225-.085.438l-1.29 5.968c-.05.232-.082.38-.115.492a.6.6 0 0 1-.069.166.5.5 0 0 1-.208.169.5.5 0 0 1-.177.032 8 8 0 0 1-.501.009H3.764Z",
      "data-figma-bg-blur-radius": "1.765"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m3.39 2.728-.324.303a.72.72 0 0 1-.492.195.816.816 0 0 0-.816.816v7.49c0 .711 0 1.067.14 1.338q.115.22.301.377c.048-.103.09-.243.146-.434l.069-.23.56-1.83c.487-1.577 1.092-3.56 1.507-4.92.174-.57.26-.854.43-1.065a1.4 1.4 0 0 1 .568-.42c.252-.102.55-.102 1.145-.102h7.466c-.011-.21-.039-.357-.103-.481a1 1 0 0 0-.427-.426c-.217-.113-.501-.113-1.07-.113H8.941c-.214 0-.32 0-.421-.024a.9.9 0 0 1-.244-.098c-.09-.053-.166-.127-.32-.276l-.09-.087c-.155-.148-.232-.222-.32-.275a.9.9 0 0 0-.245-.098c-.1-.024-.207-.024-.421-.024H4.36c-.21 0-.314 0-.414.023a.9.9 0 0 0-.24.095c-.088.05-.164.123-.317.266M13.694 13.53q-.126.003-.296.002H3.022c.197.012.44.012.748.012h9.54c.173 0 .292 0 .384-.014",
      style: {"fill-opacity":".4"}
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", { d: "m2.958 9.691.014-.047.05-.17c.138-.455.22-.727.506-1.658.477-1.555 1.08-3.544 1.453-4.771.136-.45.171-.536.217-.594a.5.5 0 0 1 .203-.15c.068-.027.162-.036.632-.036h8.011c.219 0 .35 0 .446.009.047.004.07.009.08.011a.1.1 0 0 1 .042.053c0 .01 0 .033-.005.08-.012.096-.04.224-.086.438l-1.29 5.968c-.05.232-.082.38-.115.492a.6.6 0 0 1-.068.166.5.5 0 0 1-.21.168.5.5 0 0 1-.175.033 8 8 0 0 1-.502.008H2.958" })
      ])
    ], -1)
  ])))
}
export default { render: render }